import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ClinicApp from './components/ClinicApp';
import MemberLogin from './components/MemberLogin';
import AccountPage from './components/AccountPage';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import SetupPassword from './components/SetupPassword';
import DeveloperSignOutPage from './components/DeveloperSignOutPage';

export default function App() {
  // PWA スタンドアロン時のみ画面を縦固定（Screen Orientation API）
  useEffect(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (!isStandalone) return;
    const lock = async () => {
      try {
        const scr = typeof window !== 'undefined' ? window.screen : null;
        if (scr?.orientation?.lock) {
          await scr.orientation.lock('portrait');
        }
      } catch {
        // Safari 等で非対応の場合は無視
      }
    };
    lock();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<MemberLogin />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/signout" element={<DeveloperSignOutPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/setup-password" element={<SetupPassword />} />
        <Route path="/:clinicId" element={<ClinicApp />} />
      </Routes>
    </BrowserRouter>
  );
}